module.exports = __webpack_public_path__ + "static/img/2-1.5d33bac1.png";